import { axiosApiInstance, headers } from './_httpHeaders';

// 1. 문서조회 문서 타입 코드 조회
export const getSysCodeList = (sysGroupCode) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/common/selectSysCodeList.do`,
    params: {
      sysGroupCode: sysGroupCode,
    },
  });

// 2. 비밀번호 초기화
export const sendTempPwdAdmin = (userInfo) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    //url: `${process.env.REACT_APP_API_URL}/common/sendTempPwdAdmin.do`,
    url: `${process.env.REACT_APP_API_URL}/user/system/sendTempPwdAdmin.do`,
    data: {
      userId: userInfo.userId,
      coRprsBrno: userInfo.coRprsBrno,
      usCode: userInfo.usCode,
      telNo: userInfo.telNo,
      pwd: userInfo.pwd,
      status: userInfo.status,
    },
  });

// 공통_상단 우측_알림팝업_리스트
export const selectAlramPopupList = (req) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/selectAlramPopupList.do`,
    params: { chkCnt: req },
  });

// 공통_상단 우측_알림팝업_확인체크
export const udpateAlramPopupChkYn = (req) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/udpateAlramPopupChkYn.do`,
    data: {
      resultList: req,
    },
  });
